import { render, staticRenderFns } from "./VorteilsclubHeader.vue?vue&type=template&id=d2e48efe&"
import script from "./VorteilsclubHeader.vue?vue&type=script&lang=ts&"
export * from "./VorteilsclubHeader.vue?vue&type=script&lang=ts&"
import style0 from "./VorteilsclubHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports